import { render, staticRenderFns } from "./StocktakingProduct.vue?vue&type=template&id=465270ae&scoped=true&"
import script from "./StocktakingProduct.vue?vue&type=script&lang=js&"
export * from "./StocktakingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465270ae",
  null
  
)

export default component.exports